import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAppSelector } from '../redux/hooks'
import { CONFIG } from '../../config'

interface ProtectedRouteProps {
  children: React.ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAppSelector((state) => state.auth)
  
  // For development, you can temporarily bypass auth
  const bypassAuth = CONFIG.isDevelopment && CONFIG.auth.bypassAuth
  
  if (!isAuthenticated && !bypassAuth) {
    return <Navigate to="/login" replace />
  }
  
  return <>{children}</>
}

export default ProtectedRoute